import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-section">
          <div className="footer-section">
  <img src="/images/abvig-logo.png" alt="ABVIG Logo" className="footer-logo-image" />
  <p className="footer-desc">Connecting businesses globally through innovative solutions and strategic partnerships.</p>
</div>
            {/* <p className="footer-desc">
              Connecting businesses globally through innovative solutions and strategic partnerships.
            </p> */}
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Our Services</Link></li>
              <li><Link to="/activities">Activities</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Global Business Events</h4>
            <ul>
              <li><Link to="/aicis-summits">AICIS Summits</Link></li>
              <li><Link to="/business-forum">Business & Investment Forum</Link></li>
              <li><Link to="/trade-mission">Trade & Investment Mission</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact</h4>
            <ul className="contact-list">
              <li>
                <span className="icon">📍</span>
                Hampton Apartment, Flats F4,<br />
                2 Mungo Park Close, Off Onitsha Crescent<br />
                Asokoro, Abuja, FCT
              </li>
              <li>
                <span className="icon">📞</span>
                <strong>Africa:</strong> +234 703 294 1519<br />
                <span className="icon" style={{ marginLeft: '24px' }}></span>
                +234 905 625 5065
              </li>
              <li>
                <span className="icon">📞</span>
                <strong>USA:</strong> +1-412-287-9069
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} abvig.com. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;